function removeDuplicatesFromArray(array) {
  const data = new Set(array.map(JSON.stringify))
  return Array.from(data).map(JSON.parse)
}

export default removeDuplicatesFromArray
